/**
 * Minimal API client for the platform admin app. Same JSON-envelope
 * pattern as apps/liff/lib/api-client.ts.
 */
import { useAuthStore } from './store';
import type { ApiResponse } from '@payroll/shared';

const API_BASE = import.meta.env.VITE_API_BASE ?? 'http://localhost:8787';

export class ApiError extends Error {
  constructor(public code: string, message: string, public status: number) {
    super(message);
  }
}

interface RequestOptions {
  method?: 'GET' | 'POST' | 'PATCH' | 'DELETE';
  body?: unknown;
  skipAuth?: boolean;
}

export async function apiFetch<T>(path: string, opts: RequestOptions = {}): Promise<T> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (!opts.skipAuth) {
    const jwt = useAuthStore.getState().jwt;
    if (jwt) headers.Authorization = `Bearer ${jwt}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method: opts.method ?? 'GET',
    headers,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });

  const json = (await res.json()) as ApiResponse<T>;
  if (!json.ok) throw new ApiError(json.code, json.error, res.status);
  return json.data;
}
